<app-sidebar></app-sidebar>
<main class="dashboard-main">
  <div class="dashboard-content">
    <div class="dashboard-header" style="display:flex; align-items:center; justify-content:space-between;">
      <div>
        <h1 class="dashboard-title">Invoice Management</h1>
        <div class="dashboard-welcome">Create, manage, and track all invoices</div>
      </div>
      <button *ngIf="userType === 'distributor'" class="add-btn"
        style="height:40px; padding:0 20px; background:#007bff; color:#fff; border:none; border-radius:4px; cursor:pointer;"
        (click)="openCreateModal()">
        Create Invoice
      </button>
    </div>
    <hr>

    <!-- Invoice Summary Cards -->
    <div class="invoice-summary-cards">
      <div class="summary-card">
        <div class="summary-value">{{getTotalInvoices()}}</div>
        <div class="summary-title">Total Invoices</div>
      </div>
      <div class="summary-card">
        <div class="summary-value paid">{{getPaidInvoices()}}</div>
        <div class="summary-title">Paid</div>
      </div>
      <div class="summary-card">
        <div class="summary-value overdue">{{getOverdueInvoices()}}</div>
        <div class="summary-title">Overdue</div>
      </div>
      <div class="summary-card">
        <div class="summary-value">₹{{getTotalValue() | number}}</div>
        <div class="summary-title">Total Value</div>
      </div>
    </div>

    <div class="my-6 flex flex-col md:flex-row gap-3">
      <input type="text" placeholder="Search invoices..." [(ngModel)]="searchTerm" #searchBox
        (input)="onSearch(searchBox.value)"
        class="flex-1 md:w-80 px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:border-blue-500" />
    </div>
    <div class="overflow-x-auto md:overflow-x-visible rounded-lg">
    <table class="modern-table min-w-full">
      <thead>
        <tr>
          <th>Invoice#</th>
          <th *ngIf="userType === 'distributor'">Customer invoice#</th>
          <th>Retailer</th>
          <th *ngIf="userType !== 'distributor'">Distributor</th>
          <th>Amount</th>
          <th>Status</th>
          <th>Issue Date</th>
          <!-- <th style="padding:8px; text-align:left;">Due Date</th> -->
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let inv of invoices">
          <td>{{inv.invoice_id || inv.invoice_number}}</td>
          <td *ngIf="userType === 'distributor'">{{inv.invoice_no || inv.invoice_id}}</td>
          <td>{{inv.retailer?.retailer_name || inv.retailer_name}}</td>
          <td *ngIf="userType !== 'distributor'">{{inv.distributor?.distributor_name ||
            inv.distributor_name}}</td>
          <td>₹{{inv.amount | number}}</td>
          <td>
            <span class="status" [class]="getStatusClass(inv.payment_status)">
              {{inv.payment_status | titlecase}}
            </span>
          </td>
          <td>{{inv.order_date | date:'mediumDate'}}</td>
          <!-- <td style="padding:8px;">{{inv.due_date | date:'mediumDate'}}</td> -->
          <td>
            <span class="action-btn" (click)="viewInvoice(inv)" title="View">
              <i class="fas fa-eye"></i>
            </span>
            <span class="action-btn" (click)="goToTransactions(inv)" title="Transactions">
              <i class="fas fa-exchange-alt"></i>
            </span>
            <span class="action-btn" (click)="downloadInvoice(inv)" title="Download">
              <i class="fas fa-download"></i>
            </span>
            <span class="action-btn" *ngIf="(userType === 'admin' || userType === 'super_admin') && inv.payment_status === 'pending'"
              (click)="editInvoice(inv)" title="Edit">
              <i class="fas fa-edit"></i>
            </span>
            <span class="action-btn delete" *ngIf="inv.payment_status === 'pending'" (click)="deleteInvoice(inv)"
              title="Delete">
              <i class="fas fa-trash"></i>
            </span>
          </td>
        </tr>
        <tr *ngIf="!loading && invoices.length === 0">
          <td [attr.colspan]="userType === 'distributor' ? 7 : 8" style="text-align:center; padding:24px; color:#888;">
            No invoices found</td>
        </tr>
        <tr *ngIf="loading">
          <td [attr.colspan]="userType === 'distributor' ? 7 : 8" style="text-align:center; padding:24px; color:#888;">
            Loading...</td>
        </tr>
      </tbody>
    </table>
    </div>
    <div *ngIf="pagination.totalPages > 1" class="pagination mt-6 flex flex-col sm:flex-row justify-center items-center gap-3 flex-wrap">
      <button (click)="goToPage(pagination.page - 1)" [disabled]="!pagination.hasPrev"
        class="px-3 sm:px-4 py-2 border border-gray-300 rounded-md text-sm hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors">Prev</button>
      <span class="text-sm text-gray-600">Page {{pagination.page}} of {{pagination.totalPages}}</span>
      <button (click)="goToPage(pagination.page + 1)" [disabled]="!pagination.hasNext"
        class="px-3 sm:px-4 py-2 border border-gray-300 rounded-md text-sm hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors">Next</button>
    </div>
    <app-view-invoice-modal *ngIf="showViewModal && selectedInvoice" [invoice]="selectedInvoice"
      (close)="closeViewModal()">
    </app-view-invoice-modal>
    <app-create-invoice-modal *ngIf="showCreateModal" [isEdit]="isEditMode" [invoiceData]="selectedInvoice"
      (close)="closeCreateModal()" (submitInvoice)="handleCreateInvoice($event)">
    </app-create-invoice-modal>
    <app-invoice-transactions-modal *ngIf="showTransactionsModal && selectedInvoiceForTransactions" 
      [invoiceId]="selectedInvoiceForTransactions.id"
      [invoiceNo]="selectedInvoiceForTransactions.invoice_no || selectedInvoiceForTransactions.invoice_id"
      [userType]="userType"
      (close)="closeTransactionsModal()">
    </app-invoice-transactions-modal>
  </div>
</main>